import React from 'react';
import { FiEye, FiPlay } from 'react-icons/fi';
import { useHubSite } from '../../shared';
import { ClickCard, DescriptionField, LinkFormProps, PasteLinkCard, SmallField, TitleField, useLinkForm } from './LinkCards';

// Add a video: a YouTube or Vimeo link that plays on the client's site (spec 420:13151)
const VideoForm: React.FC<LinkFormProps> = props => {
    const { host, short, ticker } = useHubSite();
    const form = useLinkForm('video', props, 'site');

    return <>
        <PasteLinkCard icon={<FiPlay />} form={form} placeholder="https://www.youtube.com/watch?v=… or a Vimeo link">
            <TitleField value={props.title} onChange={props.onTitle} />
            <div className="fields three hub-news-fields">
                <SmallField label="Source" hint="· shown under the title" value={form.fields[0]} onChange={v => form.setField(0, v)} />
                <SmallField label="Date shown on website" value={form.fields[1]} onChange={v => form.setField(1, v)} />
                <SmallField label="Length" hint="(optional)" value={form.fields[2]} onChange={v => form.setField(2, v)} />
            </div>
            <DescriptionField value={form.description} onChange={form.setDescription} />
        </PasteLinkCard>

        <section className="card hub-news-form">
            <div className="section-title">
                <span className="icon-tile"><FiEye /></span>
                <div className="text"><h2>How it plays on the website</h2><div className="hint">Investors watch without leaving {host}</div></div>
            </div>
            {/* a drawn stand-in for the player on the client's news page */}
            <div className={`hub-player${form.found ? '' : ' empty'}`}>
                <span className="hub-player-brand">{short}</span>
                <span className="hub-player-play"><FiPlay /></span>
                <span className="hub-player-t">
                    {form.found
                        ? <><strong>{props.title}</strong><span>{form.fields[0] || 'YouTube'} · 4:32</span></>
                        : <span>Paste a link and click Get Details to see the video here</span>}
                </span>
                <span className="hub-player-foot"><span>{ticker && <>ASX:<b>{ticker}</b></>}</span><span>{host.toUpperCase()}</span></span>
            </div>
        </section>

        <ClickCard form={form} newTab="Open on YouTube in a new tab" />
    </>;
};

export default VideoForm;
